import { Capacitor } from "@capacitor/core";

export const platform = (): "ios" | "android" | "web" =>
  Capacitor.getPlatform() as "ios" | "android" | "web";

export const isNative = (): boolean => Capacitor.isNativePlatform();
export const isIOS = (): boolean => platform() === "ios";
export const isAndroid = (): boolean => platform() === "android";

// Build-time flag — replaced by Vite's define at compile time so Rollup
// can tree-shake admin modules out of the mobile bundle entirely.
declare const __MOBILE_BUILD__: boolean;
export const isMobileBuild: boolean =
  typeof __MOBILE_BUILD__ !== "undefined" && __MOBILE_BUILD__;

// App version — injected from package.json at build time via Vite define.
// Single source of truth: bump package.json → version propagates everywhere.
// Usage: import { APP_VERSION } from "@/platform"
declare const __APP_VERSION__: string;
declare const __BUILD_TIME__: string;
/** ISO timestamp of the build (vite define). Empty in tests. */
export const BUILD_TIME: string =
  typeof __BUILD_TIME__ !== "undefined" ? __BUILD_TIME__ : "";
export const APP_VERSION: string =
  typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : "0.0.0";

// Capgo OTA channel baked at build time via CAPGO_CHANNEL env var.
// cap:ios / cap:android → "development"; cap:ios:prod / cap:android:prod → "production".
declare const __CAPGO_CHANNEL__: string;
export const CAPGO_CHANNEL: string =
  typeof __CAPGO_CHANNEL__ !== "undefined" ? __CAPGO_CHANNEL__ : "development";
